import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
  Card, CardBody, Row, Col
} from 'reactstrap';
import { TextField } from '../../../shared/TextField';
import { PRODUCT_GROUPS } from '../../../../config/constants';
import { Messages } from '../../../layout/Messages/Messages';
import { ErrorMessage } from 'formik';
import {
  calculateTotalPriceOnCustomOrderWithoutVat, getCustomOrderProduct
} from '../../../../helpers/general';

function SimpleSignaturesFields(props) {
  const getCurrencyOfProduct = () => {
    let productGroup;
    props.productGroups.forEach( item => {
      if (item.name === PRODUCT_GROUPS.SIMPLE_SIGNATURE.name) {
        productGroup = item;
      }
    } );

    return getCustomOrderProduct(productGroup).currency;
  }

  const calculateTotalPrice = () => {
    if (isNaN( props.formikProps.values.simpleSignaturesNumber ) || isNaN( props.formikProps.values.simpleSignaturesValue )) {
      return `0 ${getCurrencyOfProduct()}`;
    }

    let total = calculateTotalPriceOnCustomOrderWithoutVat( props.formikProps.values.simpleSignaturesNumber, props.formikProps.values.simpleSignaturesValue );

    return `${total} ${getCurrencyOfProduct()}`
  }

  return (
    <Card id="simple-signatures-content">
      <CardBody>
        <Row className="align-items-center mb-3">
          <Col xs={12} sm={3}>
            <FormattedMessage
              id="components.pages.orderManagement.selectProductGroup.simple_signatures.number"/>
          </Col>
          <Col xs={12} sm={9}>
            <TextField
              name="create_order.number"
              handleBlur={props.formikProps.handleBlur}
              value={props.formikProps.values.simpleSignaturesNumber}
              classNameFormGroup="m-0"
              onChange={e => {
                props.formikProps.setFieldValue( "simpleSignaturesNumber", e.target.value )
              }
              }
              errorClass={props.getErrorClass( props.formikProps, 'simpleSignaturesNumber' )}
            />
            <Messages
              color="danger"
              formikProps={props.formikProps}
              class="small-field-error"
              showDismiss={false}
            >
              <ErrorMessage
                name="simpleSignaturesNumber"
                component="div"
                data-testid="errors-simpleSignaturesNumber"
                className="field-error"
              />
            </Messages>
          </Col>
        </Row>
        <Row className="align-items-center mb-3">
          <Col xs={12} sm={3}>
            <FormattedMessage
              id="components.pages.orderManagement.selectProductGroup.simple_signatures.price"/>
          </Col>
          <Col xs={12} sm={9}>
            <TextField
              handleBlur={props.formikProps.handleBlur}
              name="create_order.value"
              value={props.formikProps.values.simpleSignaturesValue}
              classNameFormGroup="m-0"
              onChange={e => {
                props.formikProps.setFieldValue( "simpleSignaturesValue", e.target.value )
              }
              }
              errorClass={props.getErrorClass( props.formikProps, 'simpleSignaturesValue' )}
            />
            <Messages
              color="danger"
              formikProps={props.formikProps}
              class="small-field-error"
              showDismiss={false}
            >
              <ErrorMessage
                name="simpleSignaturesValue"
                component="div"
                data-testid="errors-simpleSignaturesValue"
                className="field-error"
              />
            </Messages>
          </Col>
        </Row>
        <Row className="create-order-total-val">
          <FormattedMessage
            id="components.pages.orderManagement.selectProductGroup.simple_signatures.sub_total"/> {calculateTotalPrice()}
        </Row>
      </CardBody>
    </Card>
  );
};


export { SimpleSignaturesFields };
